import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=2cfb9079&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=2cfb9079&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb9079",
  null
  
)

export default component.exports